module.exports = __webpack_public_path__ + "img/eva.e574cfe3.jpg";